import { render, staticRenderFns } from "./local-aplicacao.vue?vue&type=template&id=60fb2552&"
import script from "./local-aplicacao.vue?vue&type=script&lang=js&"
export * from "./local-aplicacao.vue?vue&type=script&lang=js&"
import style0 from "./local-aplicacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports